// removed by extract-text-webpack-plugin
module.exports = {"hero":"Hero-m__hero___18v-j","row":"Hero-m__row___1prY4","content":"Hero-m__content___2uHxl","header":"Hero-m__header___OEOQo","headerAccent":"Hero-m__headerAccent____du47","image":"Hero-m__image___25KuJ"};


//////////////////
// WEBPACK FOOTER
// ./components/hero/Hero.m.sass
// module id = lZbv
// module chunks = 0